import { render, staticRenderFns } from "./UpdateItemGeneral.vue?vue&type=template&id=7ba8b46b&scoped=true&"
import script from "./UpdateItemGeneral.vue?vue&type=script&lang=js&"
export * from "./UpdateItemGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UpdateItemGeneral.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateItemGeneral.vue?vue&type=style&index=1&id=7ba8b46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8b46b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
